import React from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { ToggleEmptyCartPop, removeAllItemFromCart, ToggleExitPopUp } from "../../redux/cart/cart.action";

import imgEmptyCart from '../../assets/cart-empty.jpg';
import './empty-cart.style.css';
import { selectEmptyCartPop, selectPageName } from "../../redux/cart/cart.selector";
import { createStructuredSelector } from "reselect";

const emptyCart = ({ToggleEmptyPop,removeAll,emptyPop,pageName,exitPopup}) => {

    function handleOnClick(){
        ToggleEmptyPop('');
        removeAll();
        if(pageName === 'Journey Details') {
            //exitPopup()
        }        
    }

    return (
        <div className={`empty-cart ${(emptyPop!=='')?'enable':''}`}>
            <div className="center-align"><img src={imgEmptyCart} /></div>
            <h3>Items already in cart!</h3>
            <p>Your cart already contain items from a different station. Do you want to clear the cart before proceeding?</p>
            <a onClick={()=>ToggleEmptyPop('')} className="close">close</a>
            <Link to={"/m/buy-food-in-train/"} onClick={handleOnClick} className="clear-cart">YES, CLEAR NOW</Link>
        </div>
    )
}
const mapStateToProps = createStructuredSelector({
    emptyPop: selectEmptyCartPop,
    pageName: selectPageName,
})
const mapDispatchToProps = (dispatch) => ({
    ToggleEmptyPop : (value) => dispatch(ToggleEmptyCartPop(value)),
    removeAll : () => dispatch(removeAllItemFromCart()),
    exitPopup : () => dispatch(ToggleExitPopUp()),
})

export default connect(mapStateToProps,mapDispatchToProps)(emptyCart);